"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const addDays_1 = __importDefault(require("date-fns/addDays"));
const utcToZonedTime_1 = __importDefault(require("date-fns-tz/utcToZonedTime"));
const KSA_TIMEZONE_1 = __importDefault(require("./KSA_TIMEZONE"));
// default branch pick up and drop dates
// pick: +3, drop: +4
const ksaDate = (0, utcToZonedTime_1.default)(new Date(), KSA_TIMEZONE_1.default); // get local ksa date
exports.default = {
    PICKUP: (0, addDays_1.default)(ksaDate, 3),
    DROPOFF: (0, addDays_1.default)(ksaDate, 4),
};
